module.exports = __webpack_public_path__ + "img/LOCK.434c0d25.svg";